((d, i, m) => {
    ct = t => d.createTextNode(t);
    ce = e => d.createElement(e);

    d.querySelectorAll(i).forEach(e => {
        const a = ce('a'), div = ce('div'), p = ce('p'), s = e.dataset.cookieblockSrc,
            sp = /google\.com\/maps\/embed/.test(s) ? 'Google Maps' :
                /player\.vimeo\.com\/video\//.test(s) ? 'Vimeo' :
                    /youtube(-nocookie)?\.com\/embed\//.test(s) ? 'YouTube' : undefined;

        if (!sp) return;

        // Fixing div creation instead of using innerHTML
        div.style.backgroundColor = "#CCC";
        div.style.display = "flex";
        div.style.height = e.height ? e.height + "px" : "100%";
        div.style.width = e.width ? e.width + "px" : "100%";
        div.style.position = "relative";

        const innerDiv = ce("div");
        innerDiv.style.backgroundColor = "#848484";
        innerDiv.style.borderRadius = "15px";
        innerDiv.style.height = "35%";
        innerDiv.style.width = "35%";
        innerDiv.style.position = "absolute";
        innerDiv.style.transform = "translate(85%,85%)";

        const iconP = ce("p");
        iconP.style.color = "#FFF";
        iconP.style.fontSize = "5.5em";
        iconP.style.position = "relative";
        iconP.style.top = "50%";
        iconP.style.left = "50%";
        iconP.style.margin = "0";
        iconP.style.textAlign = "center";
        iconP.style.transform = "translate(-50%,-50%)";
        iconP.textContent = "⋯";

        innerDiv.appendChild(iconP);
        div.appendChild(innerDiv);
        div.classList.add(`cookieconsent-optout-${m}`);

        a.textContent = `accept ${m} cookies`;
        a.href = 'javascript:Cookiebot.renew()';
        p.classList.add('renew-cookie-text');
        p.append(ct('Please '), a, ct(` to view this ${sp} content.`));

        div.appendChild(p); // Append p inside div (so it toggles with cookie consent)
        e.parentNode.insertBefore(div, e);
    });

})(document, 'iframe[data-cookieblock-src]', 'marketing');